import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './rush.css';
import './contact.css';
import { RushNav, RushFooter, useRushReveal } from './RushChrome';

const Hero = () => (
  <section className="contact-hero">
    <div className="hero-mesh"></div>
    <div className="rs-container hero-anim" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <span className="hero-eyebrow"><span className="dot"></span>We reply within 2 business hours</span>
      <h1 className="contact-h1">Let's talk localization.</h1>
      <p className="contact-lead">Questions about Rush Studio? Pricing for your team? Custom enterprise needs? Drop us a line — a real human will get back to you, usually the same day.</p>
    </div>
  </section>
);

const Channels = () => {
  const channels = [
    {
      title: 'Sales', desc: 'Plans, pricing, enterprise quotes, security reviews.', email: 'sales@rushstudio.com', cta: 'Book a call',
      icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 6.5l9 6 9-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><rect x="3" y="5" width="18" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.8" /></svg>),
    },
    {
      title: 'Support', desc: 'Help with your account, integrations, or the editor.', email: 'help@rushstudio.com', cta: 'Open a ticket',
      icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" /><path d="M9 9.5a3 3 0 015.83 1c0 1.5-2.83 2-2.83 3M12 17h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>),
    },
    {
      title: 'Partnerships', desc: 'Press, agencies, MT engine integrations, co-marketing.', email: 'partners@rushstudio.com', cta: 'Send a brief',
      icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M16 8l3-3 3 3v8a2 2 0 01-2 2h-2M2 16V8l3-3 3 3v8M2 16l3 3 3-3M22 16l-3 3-3-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><path d="M8 14h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>),
    },
  ];
  return (
    <section className="section-tight" style={{ paddingTop: 0 }}>
      <div className="rs-container">
        <div className="channels-grid reveal stagger">
          {channels.map((c) => (
            <a key={c.title} href={`mailto:${c.email}`} className="channel-card">
              <div className="channel-icon">{c.icon}</div>
              <div className="channel-title">{c.title}</div>
              <div className="channel-desc">{c.desc}</div>
              <div className="channel-email">{c.email}</div>
              <div className="channel-cta">{c.cta}
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h10m0 0L8 3m4 4l-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

const ContactForm = () => {
  const [sent, setSent] = useState(false);
  const [topic, setTopic] = useState('sales');
  return (
    <section className="section" id="form">
      <div className="rs-container contact-grid">
        <div className="contact-form-wrap reveal">
          <h2 className="contact-h2">Send us a message.</h2>
          <p className="contact-sub">Fill in the form — we'll route it to the right person and reply within 2 business hours.</p>

          {sent ? (
            <div className="form-success">
              <div className="success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" /><path d="M8 12.5l3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </div>
              <h3>Message received.</h3>
              <p>Thanks — we'll be in touch within 2 business hours. In the meantime, you can read our <Link to="/pricing">pricing</Link> or <Link to="/">poke around the dashboard</Link>.</p>
              <button className="btn btn-ghost" onClick={() => setSent(false)}>Send another</button>
            </div>
          ) : (
            <form className="contact-form" onSubmit={(e) => { e.preventDefault(); setSent(true); }}>
              <div className="field-row">
                <label className="field"><span>Full name</span><input className="input input-lg" placeholder="Sara Kowalski" required /></label>
                <label className="field"><span>Work email</span><input type="email" className="input input-lg" placeholder="sara@yourcompany.com" required /></label>
              </div>
              <div className="field-row">
                <label className="field"><span>Company</span><input className="input input-lg" placeholder="Acme Inc." /></label>
                <label className="field">
                  <span>Team size</span>
                  <select className="input input-lg" defaultValue="">
                    <option value="" disabled>Choose…</option>
                    <option>Just me</option>
                    <option>2–10</option>
                    <option>11–50</option>
                    <option>51–200</option>
                    <option>200+</option>
                  </select>
                </label>
              </div>
              <div className="field">
                <span>What's this about?</span>
                <div className="topic-chips">
                  {[
                    ['sales', 'Sales & pricing'],
                    ['support', 'Product support'],
                    ['enterprise', 'Enterprise / security'],
                    ['partnership', 'Partnership'],
                    ['other', 'Something else'],
                  ].map(([k, label]) => (
                    <button type="button" key={k} className={`topic-chip ${topic === k ? 'active' : ''}`} onClick={() => setTopic(k)}>{label}</button>
                  ))}
                </div>
              </div>
              <label className="field"><span>Message</span><textarea className="input input-lg textarea" rows="6" placeholder="Tell us what you're trying to do and we'll figure out how to help." required></textarea></label>
              <label className="checkbox-row">
                <input type="checkbox" defaultChecked />
                <span>Send me Rush Studio product updates. <span className="muted-note">No spam, easy to unsubscribe.</span></span>
              </label>
              <div className="form-foot">
                <button className="btn btn-accent btn-lg" type="submit">Send message →</button>
                <span className="form-note">By submitting you agree to our <Link to="/privacy">privacy notice</Link>.</span>
              </div>
            </form>
          )}
        </div>

        <aside className="contact-aside reveal">
          <div className="aside-card">
            <h4>Response times</h4>
            <ul className="aside-list">
              <li><span className="bullet sales"></span><div><b>Sales</b><span>Same business day</span></div></li>
              <li><span className="bullet support"></span><div><b>Support</b><span>Under 2 business hours</span></div></li>
              <li><span className="bullet enterprise"></span><div><b>Enterprise</b><span>Within 1 business day, dedicated rep</span></div></li>
            </ul>
          </div>

          <div className="aside-card aside-card-inverted">
            <h4>Already a customer?</h4>
            <p>Skip the form — get instant help inside the app via the help menu, or chat with us in your workspace.</p>
            <button className="btn btn-primary btn-sm">Open the app</button>
          </div>

          <div className="aside-card">
            <h4>Talk to a human</h4>
            <p>Book a 25-minute slot with our team. Walk through the dashboard, ask anything.</p>
            <div className="time-pill">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.5" /><path d="M7 4v3l2 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
              25 min · video call
            </div>
            <button className="btn btn-ghost btn-sm">Pick a time</button>
          </div>
        </aside>
      </div>
    </section>
  );
};

const Offices = () => {
  const offices = [
    { city: 'London', country: 'United Kingdom', lines: ['12 Hatton Garden', 'London EC1N 8AT'], hours: 'Mon–Fri · 9:00–18:00 GMT', flag: '🇬🇧' },
    { city: 'Berlin', country: 'Germany', lines: ['Torstraße 123', '10119 Berlin'], hours: 'Mon–Fri · 9:00–18:00 CET', flag: '🇩🇪' },
    { city: 'Lisbon', country: 'Portugal', lines: ['Av. da Liberdade 110', '1250-146 Lisboa'], hours: 'Mon–Fri · 9:00–18:00 WET', flag: '🇵🇹' },
    { city: 'New York', country: 'United States', lines: ['360 Lexington Ave, 12F', 'New York, NY 10017'], hours: 'Mon–Fri · 9:00–18:00 EST', flag: '🇺🇸' },
  ];
  return (
    <section className="section-tight" style={{ borderTop: '1px solid var(--line)' }} id="offices">
      <div className="rs-container">
        <div className="section-head reveal" style={{ textAlign: 'left', margin: '0 0 32px', maxWidth: 'none' }}>
          <div className="eyebrow">Offices</div>
          <h2 style={{ fontSize: 36 }}>Find us in four cities.</h2>
        </div>
        <div className="offices-grid reveal stagger">
          {offices.map((o) => (
            <div key={o.city} className="office-card">
              <div className="office-flag" aria-hidden="true">{o.flag}</div>
              <div className="office-city">{o.city}</div>
              <div className="office-country">{o.country}</div>
              <div className="office-lines">{o.lines.map((l) => <div key={l}>{l}</div>)}</div>
              <div className="office-hours">{o.hours}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const QuickHelp = () => (
  <section className="section">
    <div className="rs-container">
      <div className="section-head reveal">
        <div className="eyebrow">Before you write</div>
        <h2>Maybe we've already answered it.</h2>
      </div>
      <div className="quick-help-grid reveal stagger">
        <Link to="/pricing" className="quick-help-card">
          <div className="quick-help-q">How does pricing work?</div>
          <div className="quick-help-a">Four plans, monthly or yearly, every plan includes 100+ languages. See the comparison table.</div>
          <span className="quick-help-link">See pricing FAQ →</span>
        </Link>
        <Link to="/" className="quick-help-card">
          <div className="quick-help-q">What does the dashboard do?</div>
          <div className="quick-help-a">Project tracker, AI + human editor, translation memory, file integrations, deadlines — one screen.</div>
          <span className="quick-help-link">Tour the dashboard →</span>
        </Link>
        <Link to="/pricing" className="quick-help-card">
          <div className="quick-help-q">What's in Enterprise?</div>
          <div className="quick-help-a">SSO, SCIM, audit logs, custom MT engines, on-prem translation memory, SLA, dedicated CSM.</div>
          <span className="quick-help-link">Compare plans →</span>
        </Link>
      </div>
    </div>
  </section>
);

const RushContactPage = () => {
  useRushReveal();
  return (
    <div className="rs">
      <RushNav active="contact" />
      <Hero />
      <Channels />
      <ContactForm />
      <Offices />
      <QuickHelp />
      <RushFooter />
    </div>
  );
};

export default RushContactPage;
